import { lang } from '$lib/lang';
import { derived } from 'svelte/store';

export const baseFormatCurrency = (
  lang: string,
  currency: string,
  amount: number,
  options: Intl.NumberFormatOptions = {}
) => {
  return new Intl.NumberFormat(lang, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    maximumFractionDigits: Number.isInteger(Number(amount)) ? 0 : 2,
    ...options
  }).format(Number(amount));
};

export const formatCurrency = derived(lang, ($lang) => {
  return baseFormatCurrency.bind(null, $lang);
});
